import { ArrowDown, ArrowUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BottomSheet, Button, IconButton, Switch } from '../../ui';
import { DEFAULT_LAYOUT, isDefault, moveSection, showSection, type HomeSlot } from './layout';
import './customize.css';

/**
 * "Customize Home": each section can be shown or hidden and moved up or
 * down (buttons, so it works by keyboard and screen reader as well as by
 * touch). The month's total always stays first. Changes apply at once.
 */
export function CustomizeHome({
  open,
  onClose,
  layout,
  onChange,
}: {
  open: boolean;
  onClose: () => void;
  layout: readonly HomeSlot[];
  onChange: (next: HomeSlot[]) => void;
}) {
  const { t } = useTranslation();
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={t('customize.title')}
      footer={
        <Button variant="secondary" size="lg" block disabled={isDefault(layout)} onClick={() => onChange(DEFAULT_LAYOUT.map((s) => ({ ...s })))}>
          {t('customize.reset')}
        </Button>
      }
    >
      <p className="customize-note">{t('customize.note')}</p>
      <ol className="customize-list" aria-label={t('customize.sectionsLabel')}>
        {layout.map((slot, i) => {
          const name = t(`customize.sections.${slot.key}.name`);
          return (
            <li key={slot.key} className="customize-item" data-testid={`customize-${slot.key}`}>
              <Switch
                label={name}
                description={t(`customize.sections.${slot.key}.description`)}
                checked={slot.visible}
                onChange={(v) => onChange(showSection(layout, slot.key, v))}
              />
              <span className="customize-move">
                <IconButton icon={ArrowUp} label={t('customize.up', { name })} disabled={i === 0} onClick={() => onChange(moveSection(layout, slot.key, -1))} />
                <IconButton
                  icon={ArrowDown}
                  label={t('customize.down', { name })}
                  disabled={i === layout.length - 1}
                  onClick={() => onChange(moveSection(layout, slot.key, 1))}
                />
              </span>
            </li>
          );
        })}
      </ol>
    </BottomSheet>
  );
}
